<div class="modal-header">
    <h5 class="modal-title">Change your password</h5>
    <button
        (click)="activeModal.dismiss('Cross click')"
        aria-label="Close"
        class="close"
        data-dismiss="modal"
        type="button"
    >
        <i class="pbslm-close-thin-cross close-img"></i>
    </button>
</div>
<div class="modal-body">
    <iframe id="change-password-content" scrolling="no" src="/uua/change_password/"> </iframe>
</div>
